import { type HTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

export type SkeletonProps = HTMLAttributes<HTMLDivElement>;

/**
 * Animated placeholder used while content is loading.
 *
 * Renders a pulsing block that inherits its dimensions from the
 * consumer via `className` (width, height, border-radius, etc.).
 *
 * @example
 * ```tsx
 * <Skeleton className="h-4 w-32 rounded" />          // text line
 * <Skeleton className="size-10 rounded-full" />       // avatar
 * <Skeleton className="h-48 w-full rounded-card" />   // card
 * ```
 */
export function Skeleton({ className, ...props }: SkeletonProps) {
  return <div className={cn('animate-pulse rounded-md bg-primary/[0.08]', className)} {...props} />;
}
